"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyboardShortcutsBase = void 0;

var _react = _interopRequireDefault(require("react"));

var _layout = require("../../layout");

var _table = require("../../table");

var _text = require("../../text");

var _utils = require("../../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

var KeyboardShortcutsBaseComponent = function KeyboardShortcutsBaseComponent(_ref) {
  var _ref$groupTitles = _ref.groupTitles,
      groupTitles = _ref$groupTitles === void 0 ? {} : _ref$groupTitles,
      _ref$commandTitles = _ref.commandTitles,
      commandTitles = _ref$commandTitles === void 0 ? {} : _ref$commandTitles,
      ariaLabel = _ref['aria-label'];
  var columns = [{
    accessor: function accessor(_ref2) {
      var title = _ref2.data.title;
      return commandTitles[title] || title;
    },
    dataCellType: _table.CellType.Header,
    header: groupTitles['Command'] || 'Command'
  }, {
    accessor: 'win',
    header: 'Windows'
  }, {
    accessor: 'mac',
    header: 'macOS'
  }];
  return (0, _core.jsx)(_layout.Flex, {
    "aria-describedby": _constants.KEYBOARD_SHORTCUTS_MODAL_ID,
    "aria-label": ariaLabel,
    flexDirection: "column",
    role: "region",
    rowGap: "S500",
    tabIndex: 0
  }, _constants.shortcuts.map(function (group) {
    return (0, _core.jsx)(_layout.Col, {
      key: group.id,
      rowGap: "S200"
    }, (0, _core.jsx)(_text.H3, {
      fontSize: "T300",
      id: "table-".concat(group.id)
    }, groupTitles[group.title] || group.title), (0, _core.jsx)(_table.Table, {
      "aria-labelledby": "table-".concat(group.id),
      columns: columns,
      data: group.commands
    }));
  }));
};

var KeyboardShortcutsBase = (0, _utils.withTestAttributes)({
  component: 'KeyboardShortcutsBase'
})(KeyboardShortcutsBaseComponent);
exports.KeyboardShortcutsBase = KeyboardShortcutsBase;